<template>
  <div class="course-wrapper">
    <div class="main-title">
      <span class="text">{{ courseType === 1 ? '精品SPOC校本课' : '精品MOOC开放课' }}</span>
      <span class="eng">{{ courseType === 1 ? 'EXCELLENT SPOC' : 'EXCELLENT MOOC' }}</span>
      <a :href="`${$baseUrl}${abbr}/courseList/courseList.html?type=${courseType}`" class="more-btn" style="margin-top: 14px">
        <span class="btn-text">查看全部</span>
        <i class="iconfont icongengduo"></i>
      </a>
    </div>
    <!-- <div class="tags">
						<div class="tag active">全部课程</div>
					</div> -->
    <div class="course-list">
      <template v-if="homeCourseList && homeCourseList.length">
        <CourseCard
          :course-data="course"
          v-for="course in homeCourseList"
          :key="course.courseId"
        >
        </CourseCard>
      </template>
      <div v-else class="no-data">
        <img
          src="//image.zhihuishu.com/zhs_yufa_150820/ablecommons/demo/202011/e8db1963d817430a924d9def022fad09.png"
        />
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>
<script>
import CourseCard from "./../../components/CourseCard";
import config from '../../config'
export default {
  props: {
    courseType: Number
  },
  created() {
    // this.getCourseCategorys();
    this.getHomeCourseList();
  },
  components: {
    CourseCard,
  },
  data() {
    return {
      homeCourseList: [],
      courseCategorys: [],
      abbr: config.abbr
    };
  },
  methods: {
    // async getCourseCategorys() {
    //   const courseCategorys = await this.$http.getCourseCategorys();
    //   this.courseCategorys = courseCategorys;
    // },
    async getHomeCourseList() {
      const homeCourse = await this.$http.HEU.getHomeCourseList({
        '_pageable.page': 0,
        '_pageable.size': 3,
        courseType: this.courseType
      });
      this.homeCourseList = homeCourse.content;
    },
  },
};
</script>

<style lang="scss" scoped>
.course-wrapper, .notice-wrapper {
    vertical-align: top;
}

.course-wrapper {
    width: 819px;
    margin-right: 27px;
    &:first-child {
      margin-bottom: 40px;
    }
}

.course-wrapper .tags {
    display: flex;
    flex: 0 0 124px;
    font-size: 14px;
    line-height: 20px;
    flex-wrap: wrap;
}

.course-wrapper .tags .tag {
    text-align: center;
    flex: 0 0 118px;
    margin-top: 12px;
    padding: 8px 9px;
    border-radius: 7px;
    color: #3A3B47;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
}

.course-wrapper .tags .tag+.tag {
    margin-left: 22px;
}

.course-wrapper .tags .tag:nth-of-type(6n+1) {
    margin-left: 0;
}

.course-wrapper .tags .tag.active {
    background: #0C3A93;
    color: #fff;
    cursor: default;
}

.course-wrapper .course-list {
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
}
</style>